import { __decorate } from "tslib";
import { Group, Vector3 } from 'three';
import { Config } from '../../Config/Config.js';
import { LabelTextConfig } from '../../Config/LabeltextConfig.js';
import { CachedMeasure } from '../../Core/CachedMeasure.js';
import { SaveChild } from '../../Core/Save.js';
import { AnatomicalSideEnum, PlanTypeEnum, ReferenceTypeEnum } from '../../Models/CaseModel.js';
import { Consts } from '../../Utils/Consts.js';
import { VectorUtils } from '../../Utils/VectorUtils.js';
import { Hexagon } from '../Primitive/Hexagon.js';
import { LabelText } from '../Primitive/Label/LabelText.js';
export class Apex extends Group {
    get proximalAxis() {
        return this._proximalAxis;
    }
    set proximalAxis(value) {
        this._proximalAxis = value;
    }
    get distalAxis() {
        return this._distalAxis;
    }
    set distalAxis(value) {
        this._distalAxis = value;
    }
    constructor(name, viewType, axis1, axis2, side, referenceType, planType) {
        super();
        this.name = name;
        this.proximalAxis = axis1;
        this.distalAxis = axis2;
        this.add(this.hexagon = new Hexagon(viewType, Config.apex_colorHex, true), this.label = new LabelText({
            name: 'Apex label',
            color: LabelTextConfig.color,
            viewType: viewType,
            objToAnchor: this.hexagon,
            anchor: new Vector3(side == AnatomicalSideEnum.Left ? 7 : -7, 5),
            labelParams: { backgroundColor: Config.apex_colorCssAlpha, fontColor: Config.apex_fontColor, borderColor: Config.apex_colorCss, text: this.name }
        }));
        this.angularDeformity = new CachedMeasure(() => {
            const sign = (side === AnatomicalSideEnum.Left ? 1 : -1) * (referenceType === ReferenceTypeEnum.Proximal ? 1 : -1);
            const refABDir = this.proximalAxis.axisApexA.clone().sub(this.proximalAxis.axisApexB);
            const movBADir = this.distalAxis.axisApexB.clone().sub(this.distalAxis.axisApexA);
            if (!this.proximalAxis.AB_dirOrigin_perp || !this.distalAxis.AB_dirOrigin_perp) { //if third line
                if (this.proximalAxis.AB_dirOrigin_perp && VectorUtils.computeSign(movBADir, Consts.emptyVector3, this.proximalAxis.AB_dirOrigin) > 0) {
                    movBADir.multiplyScalar(-1); //movDir is the thirdLine
                }
                else if (this.distalAxis.AB_dirOrigin && VectorUtils.computeSign(refABDir, Consts.emptyVector3, this.distalAxis.AB_dirOrigin) < 0) {
                    refABDir.multiplyScalar(-1); //refDir is the thirdLine
                }
            }
            const angle = VectorUtils.linesAngleFromOrigin(refABDir, movBADir);
            return angle * sign;
        });
        this.axialTranslation = new CachedMeasure(() => {
            if (planType == PlanTypeEnum.Deformity)
                return 0;
            const reference = this.proximalAxis;
            const moving = this.distalAxis; //todo fix
            const refDir = reference.B.position.clone().sub(reference.A.position);
            const refPerp = VectorUtils.getPerpendicular(refDir);
            const int = VectorUtils.lines2DIntersection(moving.B.position, moving.B.position.clone().add(refDir), reference.B.position, reference.B.position.clone().add(refPerp));
            const sign = VectorUtils.computeSign(moving.B.position, reference.B.position, refDir);
            return moving.B.position.distanceTo(int) * sign;
        });
    }
    update() {
        this.axialTranslation.needUpdate = this.angularDeformity.needUpdate = true;
        const intersection = VectorUtils.lines2DIntersection(this._proximalAxis.axisApexA, this._proximalAxis.axisApexB, this._distalAxis.axisApexA, this._distalAxis.axisApexB);
        intersection && this.hexagon.position.copy(intersection);
        return !!intersection;
    }
}
__decorate([
    SaveChild()
], Apex.prototype, "label", void 0);
//# sourceMappingURL=Apex.js.map